import React, { useEffect, useState } from 'react';
import { Clock, Flame } from 'lucide-react';
const STORAGE_KEY = 'pcp_countdown_end_30m';
const DURATION_MINUTES = 30;
function getEndTime(): number {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (!isNaN(end) && end > Date.now()) return end;
  }
  const newEnd = Date.now() + DURATION_MINUTES * 60 * 1000;
  localStorage.setItem(STORAGE_KEY, newEnd.toString());
  return newEnd;
}
function formatUnit(n: number): string {
  return n.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const endTime = getEndTime();
    const update = () => {
      const diff = Math.max(0, endTime - Date.now());
      const h = Math.floor(diff / (1000 * 60 * 60));
      const m = Math.floor(diff / (1000 * 60) % 60);
      const s = Math.floor(diff / 1000 % 60);
      setTimeLeft({
        h,
        m,
        s
      });
      // Reset when finished
      if (diff <= 0) {
        localStorage.removeItem(STORAGE_KEY);
      }
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPricing = () => {
    const element = document.querySelector('#comprar');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={scrollToPricing} className="sticky top-0 z-50 w-full bg-gradient-to-r from-accent-700 via-accent-600 to-accent-700 text-white shadow-md hover:brightness-110 transition-all" data-id="element-65">
      <div className="container mx-auto px-3 py-2 flex items-center justify-center gap-2 md:gap-4 flex-wrap" data-id="element-66">
        <div className="flex items-center gap-1.5 md:gap-2 font-bold text-xs md:text-sm" data-id="element-67">
          <Flame className="w-4 h-4 md:w-5 md:h-5 text-yellow-300 animate-pulse" data-id="element-68" />
          <span className="uppercase tracking-wider" data-id="element-69">Oferta termina en:</span>
        </div>

        <div className="flex items-center gap-1 md:gap-1.5 font-mono" data-id="element-70">
          <TimeBlock value={timeLeft.h} label="hs" data-id="element-71" />
          <span className="text-yellow-300 font-bold text-base md:text-xl" data-id="element-72">
            :
          </span>
          <TimeBlock value={timeLeft.m} label="min" data-id="element-73" />
          <span className="text-yellow-300 font-bold text-base md:text-xl" data-id="element-74">
            :
          </span>
          <TimeBlock value={timeLeft.s} label="seg" data-id="element-75" />
        </div>

        <div className="hidden md:flex items-center gap-1.5 text-xs md:text-sm font-bold border-l border-white/30 pl-3 ml-1" data-id="element-76">
          <Clock className="w-4 h-4" data-id="element-77" />
          <span data-id="element-78">Precio sube cuando termine</span>
        </div>
      </div>
    </button>;
}
function TimeBlock({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center bg-brand-950/40 rounded-md px-2 py-0.5 min-w-[36px] md:min-w-[44px] border border-white/10" data-id="element-79">
      <span className="text-base md:text-xl font-extrabold leading-none tabular-nums" data-id="element-80">
        {formatUnit(value)}
      </span>
      <span className="text-[8px] md:text-[10px] uppercase tracking-wider opacity-70 leading-none mt-0.5" data-id="element-81">
        {label}
      </span>
    </div>;
}